module.exports = __webpack_public_path__ + "static/media/1230_elements_Genesis.85596683.png";